import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const MARK_ALL_NOTIFICATION_READ = gql`
  mutation MarkAllNotificationsAsRead {
    MarkAllNotificationsAsRead
  }
`;
